










































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Login extends Vue {
  private username: string | null = null;
  private password: string | null = null;

  async submit() {
    await this.$store.dispatch('login', {
      username: this.username,
      password: this.password,
    });

    this.$router.push({ name: 'home' });
  }
}
